/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Incident_DescriptionInputs */

const en_case_section_incident_description = /** @type {(inputs: Case_Section_Incident_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When, where, and what happened. Be specific — these notes feed the legal file.`)
};

const pt_br2_case_section_incident_description = /** @type {(inputs: Case_Section_Incident_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando, onde e o que aconteceu. Seja específico — essas notas alimentam o processo.`)
};

/**
* | output |
* | --- |
* | "When, where, and what happened. Be specific — these notes feed the legal file." |
*
* @param {Case_Section_Incident_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_incident_description = /** @type {((inputs?: Case_Section_Incident_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Incident_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_incident_description(inputs)
	return pt_br2_case_section_incident_description(inputs)
});